<template>
    <div v-if="!loading" class="m-levelPoints a-tag -large -shadow">
        <div class="m-levelPoints__lvl">
            {{ $t('general.yourLevel') }}: <div class="a-tinyBadge">{{ level }}</div>
        </div>
        <div class="m-levelPoints__points">
            {{ $t('general.yourPoints') }}: <div class="a-tag -primary">{{ points }}</div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import api from '../../services/api';

const loading = ref(true);
const level = ref(1);
const points = ref(0);

const fetchLevelPoints = async () => {
    try {
        const response = await api.get('/points-and-level');
        if (response.status === 200) {
            level.value = response.data.level;
            points.value = response.data.points;
        }
        loading.value = false;
    } catch (error) {
        console.error('Error fetching level and points:', error);
        loading.value = false;
    }
};

onMounted(() => {
    fetchLevelPoints();
});
</script>